
export default {
    male: "Male",
    female: "Female",
    male_neutered: "Male - Neutered",
    female_neutered: "Female - Neutered",
}
